declare function require(arg: string): any;

export const environment = {
  production: true
};

export const apiEndpoint = 'https://dev.kokkonias.de/OASJdoAJMFGOA2lomasoD242ASDo234oaseoqaJOsdgjosa';

export const version = require('../../package.json').version;



// WEBPACK FOOTER //
// /Users/Dimitrios/Documents/git/dvsplanungshilfe/src/environments/environment.prod.ts